<div class="solutions">
  <div class="solutions__title">
    <h1 class="font-size-headline3" data-testid="solutions-title">SOLUTIONS</h1>
    @if (solutions.length > 3) {
      <div class="solutions__buttons">
        <button
          mat-icon-button
          NguCarouselPrev
          [disabled]="disablePrevSlide()"
          [ngClass]="{ disabled: disablePrevSlide() }"
          (click)="prevSlide()"
          type="button"
        >
          <img src="../../../../../assets/svg/chevron_left.svg" alt="left arrow" class="arrow-left" />
        </button>
        <button
          mat-icon-button
          NguCarouselNext
          [disabled]="disableNextSlide()"
          [ngClass]="{ disabled: disableNextSlide() }"
          (click)="nextSlide()"
          type="button"
        >
          <img src="../../../../../assets/svg/chevron_right.svg" alt="right arrow" class="arrow-right" />
        </button>
      </div>
    }
  </div>

  @if (isFetching) {
    <!-- Skeleton Loader Template -->
    <div class="skeleton-container">
      <!-- Skeleton Loader for cards -->
      <div class="skeleton-cards">
        @for (card of [1, 2, 3]; track card) {
          <ngx-skeleton-loader
            [theme]="{ width: '450px', height: '430px', margin: '0 10px', background: 'var(--udt-white)' }"
          ></ngx-skeleton-loader>
        }
      </div>
    </div>
  } @else {
    <div class="solutions__cards">
      @if (solutions.length === 0) {
        <h4>There are not Solutions yet</h4>
      } @else {
        <owl-carousel-o [options]="customOptions" class="solutions__carousel" #owlCarousel>
          @for (slide of solutions; track slide.id) {
            <ng-template carouselSlide let-owlItem [id]="slide.id.toString()">
              <solution-card [solution]="slide" [style]="{ display: 'flex', height: '100%' }"></solution-card>
            </ng-template>
          }
        </owl-carousel-o>
      }
    </div>
  }
</div>
